//GameOn.jsx
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGamepad, faListCheck, faMinusCircle } from '@fortawesome/free-solid-svg-icons';
import './GameOn.css';
import gameonimage from '../../assets/pageimages/GameOn.webp';

function GameOnHome() {

  return (
    <MainLayout>
      <div className="bg-gradient-to-r from-teal-400 via-teal-500 to-teal-600 min-h-screen p-4 sm:p-8">
        <div className="text-center">
          <h2 className='text-2xl sm:text-3xl font-bold text-white'>
            GameOn
          </h2>
        </div>

        <div className="flex justify-center mb-8">
          <img
            id="gameon-id"
            src={gameonimage}
            alt="GameOn"
            className="w-full sm:w-3/4 lg:w-1/4 rounded-lg shadow-lg"
          />
        </div>

        <div className="bg-gradient-to-r from-purple-500 via-pink-500 to-red-500 p-6 rounded-lg shadow-lg mb-8">
          <div className="flex flex-col sm:flex-row justify-around items-center">
            <Link 
              to="/gameon-mygamelogs" 
              className="flex items-center text-white text-lg sm:text-xl font-semibold bg-blue-600 hover:bg-blue-500 rounded-lg px-6 py-3 mb-2 sm:mb-0 transition-transform transform hover:scale-105"
            >
              <FontAwesomeIcon icon={faListCheck} className="mr-2" />
              My Game Logs
            </Link>
            <Link 
              to="/gameon-tictactoe" 
              className="flex items-center text-white text-lg sm:text-xl font-semibold bg-teal-700 hover:bg-teal-600 rounded-lg px-6 py-3 mb-2 sm:mb-0 transition-transform transform hover:scale-105"
            >
              <FontAwesomeIcon icon={faGamepad} className="mr-2" />
              Tic-Tac-Toe
            </Link>
            <Link 
              to="/gameon-minesweeper" 
              className="flex items-center text-white text-lg sm:text-xl font-semibold bg-teal-700 hover:bg-teal-600 rounded-lg px-6 py-3 mb-2 sm:mb-0 transition-transform transform hover:scale-105"
            >
              <FontAwesomeIcon icon={faGamepad} className="mr-2" />
              MineSweeper
            </Link>
          </div>
        </div>

      </div>
    </MainLayout>
  );
}

export default GameOnHome;



